import {IServiceFactoryExtended} from '../../service-factory-extended.interface';

export class CasinofiedAppSdkLoader {
    constructor(private readonly _services: IServiceFactoryExtended) {
    }



    private _loadedAppsSDKs: Record<string, Promise<string>> = {};

    loadAppSdk(appId: string): Promise<string> {

        const appLauncherConfigs = this._services.configuration.servicesConfigs.AppLauncher;
        const appConfigs = appLauncherConfigs.apps[appId];

        let url = appConfigs?.url;

        if(!url && appConfigs.sdk) {
            url = appLauncherConfigs.sdks[appConfigs.sdk]?.url;
        }

        if(!url) {
            return Promise.reject(`There is no component or application with ID ${appId} configured in the catalog`);
        }

        if(this._loadedAppsSDKs[url]) {
            return this._loadedAppsSDKs[url];
        }

        let sdkloadStartTime = Date.now();
        const loadScripPromise = this._services.sdk.loadScript(url, appId + "_APPLICATION");

        return loadScripPromise.then(() => {
            this._loadedAppsSDKs[url] = loadScripPromise.then(() => url);
            this._services.casinofiedAnalytics.reportDuration("loadAppSdkOk", Date.now() - sdkloadStartTime, appConfigs.sdk || appId);
            return url;
        }).catch(err => {
            this._services.casinofiedAnalytics.reportDuration("loadAppSdkError", Date.now() - sdkloadStartTime, appConfigs.sdk || appId);
            this._services.logger.error(`Failed to load SDK for ${appId} from url ${url}`, err);
            throw err;
        });
    }
}
